var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "report-generator" },
    [
      _vm._m(0),
      _vm._v(" "),
      _c("b-button", { on: { click: _vm.generatePDF } }, [
        _vm._v("Generate PDF"),
      ]),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { attrs: { id: "report" } }, [
      _c("div", { staticClass: "primary-cost-container" }, [
        _c("div", { staticClass: "page-break-after" }, [
          _c("h1", [_vm._v("PRIMARY COST ESTIMATE")]),
          _vm._v(" "),
          _c("p", [
            _vm._v(
              "This is a calculation of materials, plant and labour for estimating purposes only (not a fixed price\n          model)."
            ),
          ]),
          _vm._v(" "),
          _c("address", [
            _c("p", [_vm._v("Mr and Mrs Sample")]),
            _vm._v(" "),
            _c("p", [_vm._v("Sample Address")]),
            _vm._v(" "),
            _c("p", [_vm._v("Sample Street")]),
            _vm._v(" "),
            _c("p", [_vm._v("AB12 3CD")]),
          ]),
          _vm._v(" "),
          _c("p", [_vm._v("Date: 13/09/23")]),
          _vm._v(" "),
          _c("p", [_vm._v("Code: 2309-1310-2601")]),
          _vm._v(" "),
          _c("p", [_vm._v("Call: 01359 256311")]),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "page-break-after" }, [
          _c("div", [
            _vm._v(
              "The is estimate is based on the information provided\n          and the responsibility is solely with you as the\n          customer to ensure the correct information is inputted.\n        "
            ),
          ]),
          _vm._v(" "),
          _c("div", [_vm._v("Project Reference: 2309-1310-260")]),
          _vm._v(" "),
          _c("div", [
            _c("div", [
              _vm._v("\n            PRIMARY COST ESTIMATE SUMMARY\n          "),
            ]),
            _vm._v(" "),
            _c("div", [
              _c("div", [
                _c("div", [_vm._v("Completion of Oversite")]),
                _vm._v(" "),
                _c("div", [_vm._v("£29,665.79")]),
              ]),
              _vm._v(" "),
              _c("div", [
                _vm._v(
                  "Included Work Sections: Site Setup, Foundations,\n              Ground Floor, Drainage, Laying Of Services\n            "
                ),
              ]),
            ]),
            _vm._v(" "),
            _c("div", [
              _c("div", [
                _c("div", [_vm._v("Completion of Wallplate")]),
                _vm._v(" "),
                _c("div", [_vm._v("£41,327.63")]),
              ]),
              _vm._v(" "),
              _c("div", [
                _vm._v(
                  "\n              Included Work Sections: Walls, Scaffolding,\n              Windows & Doors, Lintels, Steelwork, Upper Floors\n            "
                ),
              ]),
            ]),
            _vm._v(" "),
            _c("div", [
              _c("div", [
                _c("div", [_vm._v("Completion of Roof")]),
                _vm._v(" "),
                _c("div", [_vm._v("£13,717.06")]),
              ]),
              _vm._v(" "),
              _c("div", [
                _vm._v(
                  "\n              Included Work Sections: Roof, Guttering\n            "
                ),
              ]),
            ]),
            _vm._v(" "),
            _c("div", [
              _c("div", [
                _c("div", [_vm._v("Completion of Plastering")]),
                _vm._v(" "),
                _c("div", [_vm._v("£13,717.06")]),
              ]),
              _vm._v(" "),
              _c("div", [
                _vm._v(
                  "\n              Included Work Sections: 1st Fix Carpentry, 2nd Fix\n              Carpentry, Plastering, Alterations, Plumbing,\n              Electrics, Fixing Summary\n            "
                ),
              ]),
            ]),
            _vm._v(" "),
            _c("div", [
              _c("div", [
                _c("div", [_vm._v("Completion of Contract")]),
                _vm._v(" "),
                _c("div", [_vm._v("£13,717.06")]),
              ]),
              _vm._v(" "),
              _c("div", [
                _vm._v(
                  "\n              Included Work Sections: Finishes, Decorating,\n              Professional Services, Other Provisional Sums\n            "
                ),
              ]),
            ]),
            _vm._v(" "),
            _c("div", [
              _vm._v(
                "\n            Total Estimated Costs £138,012.74\n          "
              ),
            ]),
            _vm._v(" "),
            _c("div", [
              _vm._v(
                "\n            Client Total (Ex. VAT) £151,814.01\n          "
              ),
            ]),
          ]),
          _vm._v(" "),
          _c("div", [
            _c("div", [_vm._v("Options Selected:")]),
            _vm._v(" "),
            _c("div"),
          ]),
        ]),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }